<template>
  <div>
    <v-toolbar class="primary--text" color="#f5f5f5" elevation="0">
      <v-layout align-center justify-space-between>
        <v-flex shrink>
          <v-layout align-center>
            <small>ヘアカラー専門店</small>
            <v-img
              :src="`${$publicPath}img/logo.png`"
              max-width="100"
              max-height="24"
              contain
            />
          </v-layout>
        </v-flex>
        <v-flex shrink @click="goSetting">
          <b><slot /></b>
        </v-flex>
        <v-flex shrink class="text-end primary--text">
          <v-btn
            v-if="enableShopBtn"
            text
            color="primary"
            @click="shopDialog = true"
          >
            {{ shop && shop.name }}
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
          <span v-else>
            {{ shop && shop.name }}
          </span>
        </v-flex>
      </v-layout>
    </v-toolbar>

    <ShopSelection v-model="shopDialog" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ShopSelection from '@/components/ShopSelection'

export default {
  name: 'FufuHeader',
  components: {
    ShopSelection,
  },
  props: {
    enableShopBtn: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    shopDialog: false,
    settingCounter: 0,
    timerId: null,
  }),
  computed: {
    ...mapGetters(['shop']),
  },
  methods: {
    goSetting(e) {
      // console.log(e)
      if (!this.timerId) {
        this.timerId = setTimeout(() => {
          // console.log('clearTimer', this.settingCounter)
          this.timerId = null
          this.settingCounter = 0
        }, 2000)
      }
      this.settingCounter++
      if (this.settingCounter >= 10) {
        this.$router.replace({ name: 'shop' })
      }
    },
  },
}
</script>
